import React from 'react';

import type { ChipProps } from '~/components/core/Atomic/Chip/Chip';
import Chip from '~/components/core/Atomic/Chip/Chip';
import Tooltip from '~/components/core/Atomic/Tooltip';
import { OverflowList } from '~/components/core/Molecules/OverflowList';
import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';

export interface ListItem {
  id: string | number;
  chipProps: ChipProps;
}

export interface OverflowChipsListProps {
  items: ListItem[];
  overflowChipProps?: ChipProps;
}

export const OverflowChipsList: React.FC<OverflowChipsListProps> = ({ items, overflowChipProps }) => {
  const itemRenderer = (item: ListItem): React.ReactNode => {
    const { chipProps = {} } = item;
    return (
      <Chip
        key={item.id}
        {...chipProps}
        label={
          <OverflowTextWithToolTip arrow tooltipPlacement="top" maxWidth="120px">
            <>{item.chipProps?.label}</>
          </OverflowTextWithToolTip>
        }
      />
    );
  };

  const overflowRenderer = (items: ListItem[]): React.ReactNode => (
    <Tooltip
      title={
        <ul className="m-0 px-16 py-8">
          {items.map((item) => (
            <li key={item.id}>{item.chipProps?.label}</li>
          ))}
        </ul>
      }
      arrow
      placement="top"
    >
      <span>
        <Chip label={`+ ${items.length}`} {...(overflowChipProps || {})} />
      </span>
    </Tooltip>
  );

  return <OverflowList items={items} itemRenderer={itemRenderer} overflowRenderer={overflowRenderer} />;
};
